import { createLocalExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { createSessionExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { isWithinLast } from './is-within-last';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { isWithinLast30Days } from './is-within-last-30-days';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	userBelongsToBusinessUserSegCategory,
	userBelongsToSoftwareUserSegCategory,
	isInSoftwareTeam,
} from './user-segmentation';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getConditional } from './conditional-rendering';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Conditional, Condition } from './conditional-rendering/types';

export const sessionStorageProvider = createSessionExpirableStorageProvider('onboarding-core');
export const localStorageProvider = createLocalExpirableStorageProvider('onboarding-core');
